<template>
  <PageContainer>
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-8">
        <h2><span class="font-bold">{{ userStore.user.name }}</span>, why do you want to improve your sleep?</h2>
        <!-- <p>A clear purpose helps to motivate you 😊</p> -->
      </div>
      <div class="mt-6 mb-2">
        <p class="">I want to <span class="bg-teal-100">{{ userStore.goalMy }}</span> so I can...</p>
        <input type="text" name="purpose" v-model="purpose" @blur="validatePurpose" @input="validatePurpose" class="w-full text-center" :placeholder="placeholders[placeholderIndex]"/>
      </div>
      <button @click="goToNext()" :disabled="purpose === ''">Next →</button>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'OnboardingPurpose',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      goalText: undefined,
      purpose: '',
      placeholders: [
        'spend more time with the kids!',
        'have more energy during the day!',
        'feel better and live longer!',
      ],
      placeholderIndex: 0,
    }
  },
  beforeMount() {
    this.loadPurpose()
    this.revolvingPlaceholer()
  },
  watch: {
  },
  methods: {
    async loadPurpose() {
      this.purpose = this.userStore.user.purpose ?? ''
    },
    validatePurpose() {
      // TODO: Field validation for purpose.
    },
    async goToNext() {
      await this.userStore.user.updatePurpose(this.purpose)
      this.$router.push('/onboarding/import')
    },
    async revolvingPlaceholer() {
      const delay = ms => new Promise(res => setTimeout(res, ms))
      for (;;) {
        await delay(2500)
        if (this.placeholderIndex === this.placeholders.length - 1) {
          this.placeholderIndex = 0
        } else {
          this.placeholderIndex++
        }
      }
    },
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>